import Vue from 'vue'
import Router from 'vue-router'
import { DateTime } from 'luxon'
import { isAuthenticated } from './services/auth'
import SignIn from './views/SignIn.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'sign-in',
      beforeEnter: (to, from, next) => {
        if (isAuthenticated()) {
          next({ name: 'home' })
        } else {
          next()
        }
      },
      component: SignIn,
      props: { hideAppContext: true }
    },
    {
      path: '/',
      name: 'home',
      meta: { secured: true },
      redirect: () => {
        const { month, year } = DateTime.local()
        return `/month/${year}/${month < 10 ? '0' : ''}${month}`
      }
    },
    {
      path: '/month/:year/:month',
      name: 'month',
      meta: { secured: true },
      props: true,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "month" */ './views/Month.vue'),
    },
    {
      path: '/month/:year/:month/item/:itemId',
      name: 'item-edit',
      meta: { secured: true },
      props: true,
      component: () => import(/* webpackChunkName: "editItem" */ './views/EditItem.vue'),
    },
    {
      path: '/categories',
      name: 'categories',
      meta: { secured: true },
      component: () => import(/* webpackChunkName: "categories" */ './views/Categories.vue'),
    },
    {
      path: '/categories/add',
      name: 'categories-add',
      meta: { secured: true },
      component: () => import(/* webpackChunkName: "addCategory" */ './views/AddCategory.vue'),
    },
    {
      path: '/categories/:categoryId',
      name: 'categories-edit',
      meta: { secured: true },
      props: true,
      component: () => import(/* webpackChunkName: "editCategory" */ './views/EditCategory.vue'),
    },
    {
      path: '/item/add',
      name: 'item-add',
      meta: { secured: true },
      component: () => import(/* webpackChunkName: "addItem" */ './views/AddItem.vue'),
    }
    // { path: '*', component: NotFoundComponent }
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.secured)) {
    if (isAuthenticated()) {
      next()
    } else {
      next({ name: 'sign-in' })
    }
  } else {
    next()
  }
})

export default router
